// Native
import { useState } from "react"

import { Badge, ButtonGroup, Td, Tr } from "@chakra-ui/react"
import { IconButton, Section, Table, Tag } from "components"

// Config
import { Moment, Mask } from "config"

// Hooks
import { useConsultantCareers } from "hooks"

export default function({ data:consultant, ...props }){

    const [ page, setPage ] = useState(1)
    const history = useConsultantCareers(consultant.data?.id, page)

    const columns = [
        { children: 'Pin Contemplado' }, 
        { children: 'Valor do Pin' }, 
        { children: 'Data', isNumeric: true }
    ]

    return(
    <>
    <Section title="Histórico de pins">
        <ButtonGroup size="xs" isDisabled={history.isFetching}>
            <IconButton icon="refresh" isLoading={history.isFetching} onClick={history.refetch} />
        </ButtonGroup>
    </Section>

    <Table columns={columns} setPage={setPage} meta={history.data?.meta} loading={history.isLoading}>
        { history.data?.data.map(item => <Item key={item.id} data={item} />) }
    </Table>
    </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td><Badge children={item.current_career.title} /></Td>
        <Td><Tag size="sm">R$ {Mask.price(item.current_career.award)}</Tag></Td>
        <Td isNumeric fontSize="xs" children={Moment(item.created_at).format('LLL')} />
    </Tr>
)